export default {
  GROWTH_DB: "https://api-db.flashgrowth.com.br",
  API_EMAILS: "https://api-emails.flashgrowth.com.br",
};